import React, { useState, useEffect, useRef, useCallback } from "react";
import "../Contacts/Contacts.css";
import {
  Button,
  TextField,
  InputLabel,
  Grid,
  Box,
  Menu,
  Select,
  MenuItem,
  Autocomplete,
  IconButton,
  MenuList,
  Avatar,
  FormControlLabel,
  Switch,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
  useMediaQuery,
  Stack,
  Typography,
  Card,
  Divider,
  CardMedia,
  CardContent,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import InputAdornment from "@mui/material/InputAdornment";
// import { apiFetch } from "../../API/CommonApi";
import Modal from "@material-ui/core/Modal";
import {
  Controller,
  FormProvider,
  useForm,
  useFieldArray,
} from "react-hook-form";
import { notify, parseFormattedText, isMobile } from "../Common";
import { debounce, max } from "lodash";
// import CampaignIcon from "@mui/icons-material/Campaign";
// import NotificationsIcon from "@mui/icons-material/Notifications";
// import KeyTwoToneIcon from "@mui/icons-material/KeyTwoTone";
import { ReactComponent as Spinner_2 } from "../../Assets/Spinner_2.svg";
import { btnCss, TextfieldCss, ClsBtn } from "../../Styles";
import CloseIcon from "@mui/icons-material/Close";
import { createTemplateReview as apiCreateTemplateReview } from "../../API/TemplateLayer";
import { templateStatus as apiTemplateStatus } from "../../API/TemplateLayer";
import { createTemplateDraft as apiCreateTemplateDraft } from "../../API/TemplateLayer";
import { templateEditDraft as apiEditTemplateDraft } from "../../API/TemplateLayer";
import { editTemplateReview as apiEditTemplateReview } from "../../API/TemplateLayer";
import { templatePreview as apiTemplatePreview } from "../../API/TemplateLayer";
import { getTemplateTags as apiGetTemplateTags } from "../../API/TemplateLayer";
import { fetchCatalogs, fetchProducts } from "../../API/TemplateLayer";
import InsertEmoticonIcon from "@mui/icons-material/InsertEmoticon";
import EmojiPicker from "emoji-picker-react";
// import RemoveIcon from "@mui/icons-material/Remove";
// import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import PhoneInput from "react-phone-input-2";
import CallIcon from "@mui/icons-material/Call";
import LaunchIcon from "@mui/icons-material/Launch";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { capitalize } from "../Common";
import { CarouselBuilder } from "./CarouselBuilder";
import { ProductSectionsBuilder } from "./ProductSectionsBuilder";
import { backend } from "../../API/CommonApi";
import { useAuth } from "../../Context/Auth";

// const addtempcss = {
//   width: "100px",
//   height: "100px",
//   margin: "0 auto",
//   overflow: "auto",
// };

// instructions
const instructionCss = {
  backgroundColor: "#efefef",
  margin: "0 10px 10px 10px",
  borderRadius: "4px",
  color: "#14181b",
  padding: "5px",
  fontSize: "10px",
};
const BtnCSS = {
  maxWidth: "412px",
  // marginTop: "15px",
  margin: "15px 15px 0 0",
  background: "linear-gradient(272.65deg, #383194 0%, #da1e7a 100%)",
  borderRadius: " 5px",
};
const btnCsspreview = {
  color: "#33b7f6",
  textAlign: "center",
  margin: "5px 0 0 0",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  cursor: "pointer",
  gap: "10px",
  fontWeight: "normal",
  border: "1px solid #d6d6d6",
  borderRadius: "4px",
  height: "30px",
};
const custBtnCtrCss = {
  color: "#303535",
  // margin: "10px 0 10px 0",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 6px 0 0",
};
const noteCss = {
  backgroundColor: "#efefef",
  margin: "10px 10px 10px 10px",
  borderRadius: "4px",
  color: "#14181b",
  padding: "5px",
  fontSize: "10px",
};

export const AddTemplate = ({
  // WpDetails,
  loadTemplates,
  editData,
  openNewTemplate,
  setOpenNewTemplate,
  setEditData,
  businessId,
  appToken,
}) => {
  const [edit, setedit] = useState(false);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [preview, setPreview] = useState(null);
  const [emojiField, setEmojiField] = useState(null);
  const mobile = isMobile();
  const is1168px = useMediaQuery("(max-width:1168px)");
  const is900px = useMediaQuery("(max-width:900px)");
  const [typAct, setTypACT] = useState([
    {
      name: "",
      value: "",
      id: null,
    },
    {
      name: "",
      value: "",
      id: null,
    },
  ]);
  const methods = useForm({
    mode: "onBlur",
    defaultValues: {
      // call_to_action: [""],
      isButtons: false,
      category: "",
      buttons: [
        {
          type: "",
        },
      ],
      // quickReply: [""],
    },
    shouldUnregister: false,
  });

  const { handleSubmit, reset, control, formState, setValue, watch } = methods;
  const { errors } = formState;
  const watchAllFields = watch({});

  const {
    fields: buttons,
    append: appendButton,
    remove: removeButton,
  } = useFieldArray({
    control,
    name: "buttons",
  });

  const [preData, setPreData] = useState(null);
  const [ApiLoading, SetApiLoading] = useState(false);
  const [media, setMedia] = useState(null);
  const [mediaName, setMediaName] = useState(null);
  const [catalogs, setCatalogs] = useState([]); 
  const [products, setProducts] = useState([]);

  const [showHdrContentMenu, setHdrContentMenu] = useState(false);
  const [showBdyContentMenu, setBdyContentMenu] = useState(false);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const inputRef = useRef(null);
  const textFieldRef = useRef(null);
  const textFieldRef2 = useRef(null);
  const shouldRunFunctions = window.location.pathname === "/templateMessage";
  const [template_tags, setTemplate_tags] = useState(null);
  const categoryOptions = [
    {
      name: "Marketing",
      value: "marketing",
      id: 0,
    },
    {
      name: "Utility",
      value: "utility",
      id: 1,
    },
    {
      name: "Authentication",
      value: "authentication",
      id: 2,
    },
  ];
  const buttonTypes = ["COPY_CODE", "PHONE_NUMBER", "URL", "QUICK_REPLY"];
  const urlButtonTypes = ["STATIC_URL", "DYNAMIC_URL"];

  const MAX_IMAGE_SIZE_BYTES = 5 * 1024 * 1024; // 5 MB in bytes
  const MAX_VIDEO_SIZE_BYTES = 16 * 1024 * 1024; // 16 MB in bytes
  const MAX_DOCUMENT_SIZE_BYTES = 100 * 1024 * 1024; // 100 MB in bytes

  const SIZE_MAPPINGS = {
    image: MAX_IMAGE_SIZE_BYTES,
    video: MAX_VIDEO_SIZE_BYTES,
    document: MAX_DOCUMENT_SIZE_BYTES,
  };

  const handleClose = () => {
    setOpenNewTemplate(false);
    setPreData(null);
    setPreview(null);
    if (editData) {
      setEditData(null);
    }
    setSelectedMedia("image");
    setMedia(null);
    setMediaName(null);
    reset();
  };
  // const [iscatalog, setIscatalog] = useState(false);
  const validateByTemplateType = (data) => {
    const { template_type: t, cards = [], product_sections = [], commerce_catalog_id } = data;
    if (!t) return null;

    switch (t) {
      case "media_card_carousel":
        if (!cards.length) return "Add at least one card";
        for (let i = 0; i < cards.length; i++) {
          const c = cards[i];
          const hasMedia = !!(c.image_file || c.image_id || c.image_url);
          if (!hasMedia) return `Card ${i + 1}: title and image required`;
        }
        break;
      case "product_card_carousel":
        if (!commerce_catalog_id) return "Catalog ID is required";
        if (!cards.length) return "Add at least one product card";
        for (let i = 0; i < cards.length; i++) {
          if (!cards[i].product_id) return `Card ${i + 1}: product_id required`;
        }
        break;
      case "multi_product_message":
        if (!commerce_catalog_id) return "Catalog ID is required";
        if (!product_sections.length) return "Add at least one section";
        for (let i = 0; i < product_sections.length; i++) {
          const s = product_sections[i];
          if (!s.title || !(Array.isArray(s.product_ids) && s.product_ids.length)) {
            return `Section ${i + 1}: title and product_ids required`;
          }
        }
        break;
      default:
        break;
    }
    return null;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const maxSize = SIZE_MAPPINGS[selectedMedia];
      if (file.size <= maxSize) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setMedia(e.target.result);
          setMediaName(file.name);
        };
        reader.readAsDataURL(file);
      } else {
        notify(
          "info",
          `The selected file exceeds the maximum allowed size of ${
            maxSize / (1024 * 1024)
          } MB.`
        );
        setMedia(null);
        setMediaName(null);
        setSelectedMedia("image");
      }
    } else {
      setMedia(null);
      setMediaName(null);
    }
  };

  const toggleEmojiPicker = (fieldName) => {
    setEmojiField(fieldName);
    setShowEmojiPicker(!showEmojiPicker);
  };

  const handleEmojiSelect = (emoji) => {
    const currentHeaderContent = watchAllFields.header_content_text || "";
    const currentBodyContent = watchAllFields.body_content || "";

    if (emojiField === "header_content_text") {
      const updatedHeaderContent = `${currentHeaderContent}${
        emoji?.emoji || ""
      }`;
      setValue("header_content_text", updatedHeaderContent);
      setPreview({
        ...preview,
        header: updatedHeaderContent,
      });
    } else if (emojiField === "body_content") {
      const updatedBodyContent = `${currentBodyContent}${emoji?.emoji || ""}`;
      setValue("body_content", updatedBodyContent);

      setPreview({
        ...preview,
        body: updatedBodyContent,
      });
    }
  };

  useEffect(() => {
    if (showEmojiPicker && inputRef.current) {
      setTimeout(() => {
        inputRef.current.focus();
      }, 0);
    }
  }, [showEmojiPicker]);

  // on selecting Suggetions it will fill the field
  const handleSlecetSuggetion = (field, option) => {
    if (field === "header_content_text") {
      const pre = watchAllFields.header_content_text.replace(/{{[^{]*$/, "");
      setValue("header_content_text", `${pre}{{${option}}} `);
      setHdrContentMenu(false);
      textFieldRef.current.focus();
    } else if (field === "body_content") {
      const pre = watchAllFields.body_content.replace(/{{[^{]*$/, "");
      setValue("body_content", `${pre}{{${option}}} `);
      setBdyContentMenu(false);
      textFieldRef2.current.focus();
    }
  };

  const debouncedSearch = debounce((temp_Key) => {
    const Key = temp_Key.target.value;
    if (Key) {
      const lastString = Key?.slice(Key.lastIndexOf("{{") + 2);
      lastString && getTemplateTags(lastString);
    }
  }, 600);

  const getTemplateTags = (param) => {
    apiGetTemplateTags(param)
      .then((res) => {
        setTemplate_tags(res.template_tags);
      })
      .catch((error) => {
        console.error("Error", error);
        notify("error", "Something went wrong with template tags");
      });
  };

  const getPostData = (data) => {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(([key, value]) => value !== undefined)
    );
    const mergedData = { ...filteredData };
    const formData = new FormData();
    for (let key in mergedData) {
      if (data.hasOwnProperty(key)) {
        const value = mergedData[key];
        if (key === "buttons"||
          key === "cards" ||
          key === "product_sections"
        ) {
          continue;
        } else if (key === "category") {
          formData.append("category", value.value);
        } else if (
          key === "header_content_text" &&
          mergedData["header_content_type"] === "media"
        ) {
          continue;
        } else if (key === "header_content_type") {
          value === "none"
            ? formData.append(key, "")
            : formData.append(key, value);
        } else {
          formData.append(key, value);
        }
      }
    }
    return Object.fromEntries(formData);
  };

  const getPutData = (data) => {
    const filteredData = Object.fromEntries(
      Object.entries(data).filter(
        ([key, value]) => value !== undefined && value !== null
      )
    );

    const mergedData = { ...filteredData };
    const formData = new FormData();
    for (let key in mergedData) {
      if (data.hasOwnProperty(key)) {
        const value = mergedData[key];
        if (key === "category") {
          formData.append("category", value.value);
        } else if (key === "buttons" ||
          key === "cards" ||
          key === "product_sections") {
          continue;
        } else if (key === "header_example" || key === "body_example") {
          if (Array.isArray(value)) {
            const result = value.join(",");

            formData.append(`${key}`, result);
          } else {
            formData.append(`${key}`, value);
          }
        } else if (key === "header_content_type") {
          value === "none"
            ? formData.append(key, "")
            : formData.append(key, value);
        } else {
          formData.append(key, value);
        }
      }
    }
    return Object.fromEntries(formData);
  };
  // create and send to review
  const createTemplateReview = (data) => {
    SetApiLoading(true);
    var buttonData =
      data.template_type === "catalog"
        ? data.buttons
        : data.isButtons
        ? data.buttons
        : [];
    if (data.template_type === "catalog") {
      delete data.template_type;
    }
    // data = getPostData(data);
    apiCreateTemplateReview(data, selectedMedia, buttonData)
      .then((res) => {
        loadTemplates();
        handleClose();
        SetApiLoading(false);
        notify("success", "Template Saved");

        reset();
      })
      .catch((error) => {
        console.error("Error", error);
        notify("error", "Something went wrong");
        SetApiLoading(false);
      });

    //reset();
  };

  // create and send to Draft
  const createTemplateDraft = (data) => {
    SetApiLoading(true);
    var buttonData =
      data.template_type === "catalog"
        ? data.buttons
        : data.isButtons
        ? data.buttons
        : [];
    if (data.template_type === "catalog") {
      delete data.template_type;
    }
    // data = getPostData(data);
    apiCreateTemplateDraft(data, selectedMedia, buttonData)
      .then((res) => {
        shouldRunFunctions && loadTemplates();
        handleClose && handleClose();
        SetApiLoading(false);
        notify("success", "Template Saved");

        reset();
      })
      .catch((error) => {
        console.error("Error", error);
        SetApiLoading(false);
        notify("error", "Something went wrong");
      });
  };

  // Edit Template send to draft
  const TemplateEditDraft = (data) => {
    SetApiLoading(true);
    var buttonData =
      data.template_type === "catalog"
        ? data.buttons
        : data.isButtons
        ? data.buttons
        : [];
    if (data.template_type === "catalog") {
      delete data.template_type;
    }
    // data = getPutData(data);
    apiEditTemplateDraft(editData.id, data, selectedMedia, buttonData)
      .then((res) => {
        loadTemplates();
        handleClose();
        edit && setedit(null);
        notify("success", "Template updated");
        SetApiLoading(false);

        reset();
      })
      .catch((error) => {
        console.error("Error", error);
        SetApiLoading(false);
        notify("error", "Something went wrong");
      });
  };

  // Edit template Send to Review
  const TemplateEditReview = (data) => {
    SetApiLoading(true);
    var buttonData =
      data.template_type === "catalog"
        ? data.buttons
        : data.isButtons
        ? data.buttons
        : [];
    if (data.template_type === "catalog") {
      delete data.template_type;
    }
    // data = getPutData(data);
    apiEditTemplateReview(editData.id, data, selectedMedia, buttonData)
      .then((res) => {
        loadTemplates();
        handleClose();
        edit && setedit(null);
        SetApiLoading(false);
        notify("success", "Template updated");

        reset();
      })
      .catch((error) => {
        console.error("Error", error);
        SetApiLoading(false);
        notify("error", "Something went wrong");
      });
  };
  const templatePreview = (body) => {
    if (body.body_content) {
      apiTemplatePreview(body).then((res) => {
        setPreview(res);
        setPreviewLoading(false);
      });
    }
  };

  const buildLocalUrl = (path) => {
    if (!path) return null;
    return `${backend}media/${path}`;
  };

  const buildCardPreview = (cards) =>
    (Array.isArray(cards) ? cards : []).map((c) => ({
      ...c,
      image_url: c.image_url || buildLocalUrl(c.image_file_path),
      _preview_src: c.image_file
        ? URL.createObjectURL(c.image_file)
        : c.image_url || buildLocalUrl(c.image_file_path),
    }));

  const handlePreview = debounce(() => {
    if (watchAllFields.body_content) {
      const t = watchAllFields.template_type;
      const isInteractive = ["media_card_carousel","product_card_carousel","multi_product_message"].includes(t);
      if (!isInteractive) {
        // HSM: keep existing apiTemplatePreview flow
        setPreviewLoading(true);
        var intervalID = setInterval(() => {
          templatePreview({
            body_content: watchAllFields.body_content,
            body_example:
              typeof watchAllFields.body_example === "string"
                ? watchAllFields.body_example?.split(",")
                : watchAllFields.body_example,
            footer_content: watchAllFields?.footer_content,
            header_content_text: watchAllFields?.header_content_text,
            header_example:
              typeof watchAllFields.header_example === "string"
                ? watchAllFields.header_example?.split(",")
                : watchAllFields.header_example,
            buttons: watchAllFields?.buttons,
          });
        }, 1000);
        setTimeout(() => {
          clearInterval(intervalID);
        }, 1500);
        return;
      }

      // Interactive: local preview from form state
      setPreviewLoading(true);
      const baseCards = watchAllFields.cards || [];
      const baseSections = watchAllFields.product_sections || [];

      const finalCards =
        t === "product_card_carousel"
          ? enrichCardsWithProducts(baseCards, products)
          : buildCardPreview(baseCards);

      const finalSections =
        t === "multi_product_message"
          ? enrichSectionsWithProducts(baseSections, products)
          : [];

      const previewObj = {
        header: watchAllFields.header_content_text || media || "",
        body: watchAllFields.body_content || "",
        footer: watchAllFields.footer_content || "",
        cards: finalCards,
        product_sections: finalSections,
        buttons: watchAllFields.buttons || [],
      };
      setPreview(previewObj);
      setPreviewLoading(false);
    }
  }, 500);

  useEffect(() => {
    if (
      typeof watchAllFields.header_content_text === "string" &&
      watchAllFields.header_content_text.endsWith("{{")
    ) {
      getTemplateTags(" ");
      setHdrContentMenu(true);
    }
    if (
      typeof watchAllFields.header_content_text === "string" &&
      watchAllFields.header_content_text.endsWith("}}")
    ) {
      setHdrContentMenu(false);
    }

    if (
      typeof watchAllFields.body_content === "string" &&
      watchAllFields.body_content.endsWith("{{")
    ) {
      getTemplateTags(" ");
      setBdyContentMenu(true);
    }
    if (
      typeof watchAllFields.body_content === "string" &&
      watchAllFields.body_content.endsWith("}}")
    ) {
      setBdyContentMenu(false);
    }
  }, [watchAllFields.header_content_text, watchAllFields.body_content]);

  const cardInsideButtons = (data) => {
    const buttons = typeof data === "string" ? JSON.parse(data) : data;
    return (
      <div>
        {buttons?.some(
          (obj) =>
            obj.type === "URL" ||
            obj.type === "PHONE_NUMBER" ||
            obj.type === "Catalog"
        ) &&
          buttons.length > 0 && <Divider />}
        {buttons?.map((item, index) => {
          if (
            item.type === "URL" ||
            item.type === "PHONE_NUMBER" ||
            item.type === "Catalog"
          ) {
            return (
              <p key={index} style={btnCsspreview}>
                {item.type === "PHONE_NUMBER" && (
                  <CallIcon
                    style={{
                      width: "20px",
                      marginRight: "-5px",
                    }}
                  />
                )}
                {item.type === "URL" && (
                  <LaunchIcon
                    style={{
                      width: "20px",
                      marginRight: "-5px",
                    }}
                  />
                )}
                {item.type === "URL" && item.url_type === "DYNAMIC_URL" && (
                  <span style={{ fontStyle: "italic", color: "#666" }}>
                    {" "}
                    (dynamic)
                  </span>
                )}
                {item.type === "Catalog" && (
                  <LaunchIcon
                    style={{
                      width: "20px",
                      marginRight: "-5px",
                    }}
                  />
                )}
                {item.type === "URL" && item.url_type === "DYNAMIC_URL" ? (
                  <span title="Dynamic URL - will be populated at send time">
                    {item.dynamic_url_placeholder || item.text}
                  </span>
                ) : (
                  item.text
                )}
              </p>
            );
          }
          return null; // Ensures that map always returns something
        })}
      </div>
    );
  };
  const cardOutSideButtons = (data) => {
    const buttons = typeof data === "string" ? JSON.parse(data) : data;

    if (
      buttons?.some(
        (obj) => obj.type === "QUICK_REPLY" || obj.type === "COPY_CODE"
      )
    ) {
      return (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            maxWidth: "295px",
            width: "100%",
            gap: "3px",
            paddingTop: "5px",
          }}
        >
          {buttons?.map((item, index) => {
            if (item.type === "QUICK_REPLY" || item.type === "COPY_CODE") {
              return (
                <p
                  key={index}
                  style={{
                    color: "#33b7f6",
                    textAlign: "center",
                    background: "#ffffff",
                    minWidth: "100px",
                    cursor: "pointer",
                    padding: "8px",
                    borderRadius: "8px",
                    width: "100%",
                    // maxWidth: "300px",
                    flexGrow: "2",
                  }}
                >
                  {item.type === "COPY_CODE" ? (
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                      }}
                    >
                      <ContentCopyIcon
                        style={{
                          width: "20px",
                          marginRight: "5px",
                        }}
                      />
                      Copy Code
                    </span>
                  ) : (
                    item?.text
                  )}
                </p>
              );
            }
          })}
        </div>
      );
    }
  };
  useEffect(() => {
    if (watchAllFields.template_type === "catalog") {
      setValue("buttons.0.type", "Catalog");
      setValue("buttons.0.text", "View catalog");
    }
  }, [watchAllFields.template_type]);

  useEffect(() => {
    if (editData) {
      const preCategory = categoryOptions.find(
        (p) => p.value === editData.category
      );
      setPreviewLoading(true);
      // console.log(editData);
      apiTemplatePreview({ template_name: editData?.name })
        .then((res) => {
          setPreview(res);
          setPreviewLoading(false);
        })
        .catch((error) => {
          console.error("Error", error);
          notify("error", "Something went wrong with Preview");
        });

      if (typeof editData?.header_content_image === "string" && editData.header_content_image) {
        setSelectedMedia("image");
        setMedia(editData.header_content_image); // now a full URL
        setMediaName(editData.header_content_image.split("/").pop());
      } else if (editData.header_content_document !== null) {
        setSelectedMedia("document");
        setMedia(editData.header_content_document);
        setMediaName(
          editData.header_content_document.substring(
            editData.header_content_document.lastIndexOf("/") + 1,
            editData.header_content_document.lastIndexOf("?")
          )
        );
      } else if (editData.header_content_video !== null) {
        setSelectedMedia("video");
        setMedia(editData.header_content_video);
        setMediaName(
          editData.header_content_video.substring(
            editData.header_content_video.lastIndexOf("/") + 1,
            editData.header_content_video.lastIndexOf("?")
          )
        );
      } else {
        //setSelectedMedia("location");
      }
      // ✅ populate cards into builder
      if (Array.isArray(editData.cards) && editData.cards.length > 0) {
        setValue("cards", editData.cards);
      }

      // ✅ populate product_sections into builder
      if (Array.isArray(editData.product_sections) && editData.product_sections.length > 0) {
        setValue("product_sections", editData.product_sections);
      }

      // console.log("selectedOption", selectedOption);
      setedit(true);
      setValue("name", editData.name);
      setValue("body_content", editData.body_content);
      setValue("footer_content", editData.footer_content);
      setValue("header_example", editData.header_example);
      setValue("body_example", editData.body_example);
      setValue("category", preCategory);
      setValue("template_type", editData.template_type);
      if (editData.commerce_catalog_id) {
        const selectedCatalog = catalogs.find(c => c.id === editData.commerce_catalog_id);
        if (selectedCatalog) {
          setValue("catalog_obj", selectedCatalog);
          setValue("commerce_catalog_id", selectedCatalog.id);
          fetchProducts(selectedCatalog.id, appToken).then(setProducts).catch(() => setProducts([]));
        } else {
          setValue("commerce_catalog_id", editData.commerce_catalog_id);
          fetchProducts(editData.commerce_catalog_id, appToken).then(setProducts).catch(() => setProducts([]));
        }
      }

      if (editData.template_type === "template"){
        setValue("template_type", "custom");
      }
      //setMedia(editData.header_content_image);
      if (editData.header_content_type === "text") {
        setValue("header_content_text", editData.header_content_text);
      }
      if (editData.buttons && editData.buttons[0]?.type === "Catalog") {
        setValue("template_type", "catalog");
        setValue(`buttons`, editData?.buttons);
        setValue("thumbnail_image_id", editData.thumbnail_image_id);
        setValue("header_content_text", editData.header_content_text);
      }
      const val = editData?.header_content_type || "none";
      setValue("header_content_type", val);
      if (
        editData?.buttons.length > 0 &&
        editData.buttons[0].type !== "Catalog"
      ) {
        setValue("isButtons", true);
        setValue(`buttons`, editData?.buttons);
      }
    } else {
      reset();
      setedit(false);
      // setValue("buttons", btnOptions[0]);
    }
    if (openNewTemplate) {
      fetchCatalogs(businessId, appToken)
        .then(setCatalogs)
        .catch(() => notify("error", "Failed to load catalogs"));
    }
  }, [openNewTemplate]);

  // when catalog changes: set commerce_catalog_id and load products
  const handleCatalogChange = async (catalogObj) => {
    setValue("commerce_catalog_id", catalogObj?.id || "");
    try {
      const list = await fetchProducts(catalogObj?.id, appToken);
      setProducts(list || []);
    } catch {
      notify("error", "Failed to load products");
      setProducts([]);
    }
  };


  // enrich sections with full product objects for preview
  const enrichSectionsWithProducts = (sections, productsList) =>
    (sections || []).map((s) => ({
      ...s,
      products: (s.product_ids || [])
        .map((rid) => productsList.find((p) => p.retailer_id === rid))
        .filter(Boolean),
    }));

  // enrich product cards with full product data if only retailer_id present
  const enrichCardsWithProducts = (cards, productsList) =>
    (cards || []).map((c) => {
      if (!c.product_id) return c;
      const prod = productsList.find((p) => p.retailer_id === c.product_id);
      return prod
        ? {
            ...c,
            title: c.title || prod.name,
            price: c.price || prod.price,
            image_url: c.image_url || prod.image_url,
          }
        : c;
    });

  const [fieldFocus, setFieldFocus] = useState({
    name: false,
    header_content_text: false,
    header_example: false,
    body_content: false,
    body_example: false,
    footer_content: false,
    category: false,
    buttons: false,
  });

  const headerOptions = ["none", "text", "media"];
  const [selectedMedia, setSelectedMedia] = useState("image");
  const handleMediaChange = (e) => {
    setMedia(null);
    setMediaName(null);
    setSelectedMedia(e.target.value);
  };

  const handleFocus = useCallback((field) => {
    setFieldFocus({
      ...fieldFocus,
      [field]: true,
    });
  }, []);

  const handleBlur = useCallback((field) => {
    setFieldFocus({
      ...fieldFocus,
      [field]: false,
    });
  }, []);

   const onSubmit = (buttonType) => {

    const data = methods.getValues();
    const err = validateByTemplateType(data);
    if (err) {
      notify("error", err);
      return;
    }

    
    // const buttonType = window.event.submitter.name;
    let updatedData = data;
    
    // normalize "custom" to backend "template"
    if (updatedData.template_type === "custom") {
      updatedData.template_type = "template";
    }
    if (
      updatedData.header_content_type === "none" || 
      updatedData.header_content_type === "undefined" || 
      !updatedData.header_content_type
    ) {
      updatedData.header_content_type = "";
    }

    if (mediaName && media) {
      const isURL = /^https?:\/\/\S+$/i.test(media);
      if (!isURL) {
        updatedData = {
          ...updatedData,
          file: [media],
          fileName: mediaName,
        };
      }
    }


    if (editData) {
      // console.log("Edit");
      if (buttonType === "send_to_draft") {
        // console.log("edit as draft");
        TemplateEditDraft(updatedData);
      } else {
        // console.log("Send To review from edit");
        TemplateEditReview(updatedData);
      }
    } else {
      // console.log("Save");
      if (buttonType === "send_to_draft") {
        // console.log("save as draft");

        createTemplateDraft(updatedData);
      } else {
        // console.log("Send To review");
        createTemplateReview(updatedData);
      }
    }
  };

  return (
    <div>
      <Dialog
        open={openNewTemplate}
        onClose={handleClose}
        fullScreen={mobile}
        maxWidth={mobile ? false : "md"}
        PaperProps={{
          style: {
            width: is1168px ? "100%" : "65%",
            height: is1168px ? "100%" : "90%",
            overflow: "auto",
          },
        }}
      >
        <DialogTitle
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          {edit ? "Update Template" : "Add Template"}
          <CloseIcon onClick={handleClose} style={{ cursor: "pointer" }} />
        </DialogTitle>

        <DialogContent dividers>
          <Stack flexDirection={"row"} gap={2}>
            <div
              style={{ maxWidth: "400px", width: "100%", minWidth: "300px" }}
            >
              <FormProvider {...methods} enctype="multipart/form-data">
                <form>
                  <div>
                    <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                      Category *
                    </InputLabel>
                    <Controller
                      render={({ field: { value, onChange } }) => (
                        <Autocomplete
                          style={{ maxWidth: "390px" }}
                          value={value}
                          // defaultValue={null}
                          options={categoryOptions}
                          getOptionLabel={(option) =>
                            option ? option.name : ""
                          }
                          onChange={(e, data) => onChange(data)}
                          isOptionEqualToValue={(option, value) =>
                            option.id === value.id
                          }
                          renderInput={(params) => (
                            <TextField
                              onKeyUp={handlePreview}
                              {...params}
                              size="small"
                              error={Boolean(errors.category)}
                              onFocus={() => handleFocus("category")}
                              onBlur={() => {
                                // handlePreview();
                                handleBlur("category");
                              }}
                              helperText={
                                errors.category && "Category is required"
                              }
                            />
                          )}
                        />
                      )}
                      rules={{ required: true }}
                      name="category"
                      control={control}
                    />
                    {fieldFocus.category && (
                      <div
                        style={{
                          backgroundColor: "#efefef",
                          margin: "10px 10px 10px 10px",
                          borderRadius: "4px",
                          color: "#14181b",
                          padding: "5px",
                          fontSize: "10px",
                        }}
                      >
                        <p style={{ marginBottom: "5px" }}>
                          Choose a category that best describes your message
                          template.
                        </p>
                        <div
                          style={{
                            marginBottom: "5px",
                          }}
                        >
                          <div>
                            <p>
                              <strong>Marketing</strong>
                            </p>
                            <p>
                              Send promotions or information about your
                              products, services or business.
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            marginBottom: "5px",
                          }}
                        >
                          <div>
                            <p>
                              <strong>Utility</strong>
                            </p>
                            <p>
                              Send messages about an existing order or account.
                            </p>
                          </div>
                        </div>
                        <div
                          style={{
                            marginBottom: "5px",
                          }}
                        >
                          <div>
                            <p>
                              <strong> Authentication</strong>
                            </p>
                            <p>Send codes to verify a transaction or login.</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  {watchAllFields.category?.value === "marketing" && (
                    <div>
                      <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                        Template Type *
                      </InputLabel>
                      <Controller
                        render={({ field: { value, onChange } }) => (
                          <Autocomplete
                            style={{ maxWidth: "390px" }}
                            value={value}
                            defaultValue={"custom"}
                            options={["custom", "catalog", "media_card_carousel", "product_card_carousel", "multi_product_message"]}
                            getOptionLabel={(option) => capitalize(option)}
                            onChange={(e, data) => onChange(data)}
                            isOptionEqualToValue={(option, value) =>
                              option.id === value.id
                            }
                            renderInput={(params) => (
                              <TextField
                                // onKeyUp={handlePreview}
                                {...params}
                                size="small"
                                error={Boolean(errors.template_type)}
                                // onFocus={() => handleFocus("template_type")}
                                // onBlur={() => {
                                //   // handlePreview();
                                //   handleBlur("template_type");
                                // }}
                                helperText={
                                  errors.template_type &&
                                  "Template type is required"
                                }
                              />
                            )}
                          />
                        )}
                        // rules={{ required: true }}
                        name="template_type"
                        control={control}
                      />
                    </div>
                  )}
                  <div>
                    <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                      Name *
                    </InputLabel>
                    <Controller
                      render={({ field }) => (
                        <TextField
                          onKeyUp={handlePreview}
                          {...field}
                          size="small"
                          fullWidth
                          onFocus={() => handleFocus("name")}
                          onBlur={() => handleBlur("name")}
                          sx={{
                            maxWidth: "388.58px",
                            width: "100%",
                            marginBottom: "10px",
                          }}
                          error={Boolean(errors?.name)}
                          helperText={
                            errors?.name?.type === "required"
                              ? "Name is required"
                              : errors?.name?.type === "pattern"
                              ? "Name can only have lowercase / numbers / underscore."
                              : ""
                          }
                          value={field.value || ""}
                        />
                      )}
                      rules={{ required: true, pattern: /^[a-z0-9_]+$/ }}
                      name="name"
                      control={control}
                    />
                    {fieldFocus.name && (
                      <div style={instructionCss}>
                        <p style={{ marginBottom: "5px" }}>
                          Name your message template.
                        </p>
                        <p>
                          {" "}
                          Name can only have lowercase / numbers / underscore.
                        </p>
                      </div>
                    )}
                  </div>
                  {watchAllFields.template_type !== "media_card_carousel" && 
                   watchAllFields.template_type !== "product_card_carousel" && (
                  <>
                  <div>
                    <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                      Header Content
                    </InputLabel>

                    <Controller
                      name="header_content_type"
                      control={control}
                      render={({ field: { value, onChange } }) => (
                        <Autocomplete
                          readOnly={
                            watchAllFields.template_type === "catalog"
                              ? true
                              : false
                          }
                          style={{ maxWidth: "390px" }}
                          value={value}
                          defaultValue={headerOptions[0]}
                          options={headerOptions}
                          getOptionLabel={(option) => capitalize(option) || ""}
                          onChange={(e, data) => {
                            onChange(data);
                            setMedia(null);
                            setMediaName(null);
                          }}
                          disableClearable
                          isOptionEqualToValue={(option, value) =>
                            option === value
                          }
                          renderInput={(params) => (
                            <TextField {...params} size="small" />
                          )}
                        />
                      )}
                    />

                    {watchAllFields?.header_content_type === "text" && (
                      <>
                        <Controller
                          name="header_content_text"
                          control={control}
                          render={({ field: { value, onChange } }) => (
                            <TextField
                              onKeyUp={handlePreview}
                              inputProps={{ ref: textFieldRef, maxLength: 60 }}
                              value={value}
                              onFocus={() => handleFocus("header_content_text")}
                              onBlur={() => {
                                handleBlur("header_content_text");
                              }}
                              onChange={(x) => {
                                onChange(x);
                                debouncedSearch(x);
                              }}
                              size="small"
                              fullWidth
                              sx={{
                                maxWidth: "388.58px",
                                width: "100%",
                                marginBottom: "10px",
                                marginTop: "10px",
                              }}
                              InputProps={{
                                endAdornment: (
                                  <InputAdornment
                                    position="end"
                                    style={{
                                      position: "absolute",
                                      bottom: "20px",
                                      right: "0",
                                    }}
                                  >
                                    <div
                                      className={`rotate-button`}
                                      onClick={() =>
                                        toggleEmojiPicker("header_content_text")
                                      }
                                      style={{
                                        cursor: "pointer",
                                        transform: "scale(0.8)",
                                      }}
                                    >
                                      <InsertEmoticonIcon />
                                    </div>
                                  </InputAdornment>
                                ),
                              }}
                            />
                          )}
                        />
                        <div
                          style={{
                            fontSize: "14px",
                            color: "gray",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            flexDirection: "column",
                          }}
                        >
                          {watchAllFields.header_content_text
                            ? `${watchAllFields.header_content_text.length}/60`
                            : "0/60"}
                        </div>
                      </>
                    )}
                    {watchAllFields?.header_content_type === "media" && (
                      <Stack>
                        <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                          Select a media Type
                        </InputLabel>
                        <Stack
                          flexDirection={"row"}
                          alignItems={"center"}
                          justifyContent={"space-around"}
                          gap={1}
                        >
                          <Select
                            value={selectedMedia}
                            onChange={handleMediaChange}
                            size="small"
                          >
                            <MenuItem value="image">Image</MenuItem>
                            <MenuItem value="document">Document</MenuItem>
                            <MenuItem value="video">Video</MenuItem>
                            {/* <MenuItem value="location">Location</MenuItem> */}
                          </Select>
                          {selectedMedia !== "none" && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <input
                                accept={
                                  selectedMedia === "image"
                                    ? "image/jpeg,image/jpg,image/png"
                                    : selectedMedia === "document"
                                    ? ".pdf"
                                    : selectedMedia === "video"
                                    ? "video/mp4"
                                    : ""
                                }
                                type="file"
                                id="upload-media"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                                name="file"
                              />
                              <div style={{ float: "right" }}>
                                <label htmlFor="upload-media">
                                  <Button variant="contained" component="span">
                                    Upload {selectedMedia}
                                  </Button>
                                </label>
                                <p
                                  style={{
                                    maxWidth: "180px",
                                    wordBreak: "break-all",
                                    overflowWrap: "break-word",
                                  }}
                                >
                                  {mediaName}
                                </p>
                              </div>
                            </div>
                          )}
                        </Stack>
                      </Stack>
                    )}
                    {showHdrContentMenu &&
                      watchAllFields.header_content_text && (
                        <div className="suggetionsCtr">
                          <MenuList>
                            {template_tags?.length > 0 ? (
                              template_tags.map((tag, index) => (
                                <MenuItem
                                  key={index}
                                  onClick={() =>
                                    handleSlecetSuggetion(
                                      "header_content_text",
                                      tag
                                    )
                                  }
                                >
                                  {tag}
                                </MenuItem>
                              ))
                            ) : (
                              <p style={{ textAlign: "center" }}>Loadding...</p>
                            )}
                          </MenuList>
                        </div>
                      )}
                    {fieldFocus.header_content_text && (
                      <div style={instructionCss}>
                        <p style={{ marginBottom: "5px" }}>
                          Add a title to your message .
                        </p>
                        <p>
                          To add variables to Title ,use placeholders like
                          &#123;&#123;1&#125;&#125;,&#123;&#123;2&#125;&#125;etc.
                        </p>
                      </div>
                    )}
                  </div>
                  {watchAllFields?.header_content_type === "text" && (
                    <div>
                      <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                        Header Example
                      </InputLabel>
                      <>
                        <Controller
                          render={({ field }) => (
                            <TextField
                              onKeyUp={handlePreview}
                              onFocus={() => handleFocus("header_example")}
                              onBlur={() => {
                                // handlePreview();
                                handleBlur("header_example");
                              }}
                              {...field}
                              size="small"
                              fullWidth
                              inputProps={{ maxLength: 100 }}
                              sx={{
                                maxWidth: "388.58px",
                                width: "100%",
                                marginBottom: "10px",
                              }}
                            />
                          )}
                          name="header_example"
                          control={control}
                        />
                        <div
                          style={{
                            fontSize: "14px",
                            color: "gray",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            flexDirection: "column",
                          }}
                        >
                          {watchAllFields.header_example
                            ? `${watchAllFields.header_example.length}/100`
                            : "0/100"}
                        </div>
                      </>
                      {fieldFocus.header_example && (
                        <div style={instructionCss}>
                          <p style={{ marginBottom: "5px" }}>
                            Add variables to Title.
                          </p>
                          <p style={{ marginBottom: "5px" }}>
                            Separate Variables with "," (comma) .
                          </p>
                        </div>
                      )}
                    </div>
                  )}</>
                  )}
                  {watchAllFields.template_type === "catalog" && (
                    <div>
                      <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                        Thumbnail iD
                      </InputLabel>
                      <Controller
                        render={({ field }) => (
                          <TextField
                            // onKeyUp={handlePreview}
                            {...field}
                            size="small"
                            fullWidth
                            // onFocus={() => handleFocus("name")}
                            // onBlur={() => handleBlur("name")}
                            sx={{
                              maxWidth: "388.58px",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                            error={Boolean(errors?.thumbnail_image_id)}
                            // helperText={
                            //   errors?.name?.type === "required"
                            //     ? "Name is required"
                            //     : errors?.name?.type === "pattern"
                            //     ? "Name can only have lowercase / numbers / underscore."
                            //     : ""
                            // }
                          />
                        )}
                        // rules={{ required: true, pattern: /^[a-z0-9_]+$/ }}
                        name="thumbnail_image_id"
                        control={control}
                      />
                    </div>
                  )}
                  {/*  Body Content */}
                  <div>
                    <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                      Body Content *
                    </InputLabel>
                    <div>
                      <Controller
                        render={({ field: { value, onChange } }) => (
                          <TextField
                            onKeyUp={handlePreview}
                            inputProps={{ ref: textFieldRef2, maxLength: 1024 }}
                            value={value || ""}
                            onFocus={() => handleFocus("body_content")}
                            onBlur={() => {
                              // handlePreview();
                              handleBlur("body_content");
                            }}
                            onChange={(x) => {
                              onChange(x);
                              debouncedSearch(x);
                            }}
                            size="small"
                            fullWidth
                            multiline
                            rows={4}
                            sx={{
                              maxWidth: "388.58px",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                            error={Boolean(errors?.body_content)}
                            helperText={
                              errors?.body_content && "Body Content is required"
                            }
                            InputProps={{
                              endAdornment: (
                                <InputAdornment
                                  position="end"
                                  style={{
                                    position: "absolute",
                                    bottom: "30px",
                                    right: "0",
                                  }}
                                >
                                  <div
                                    className={`rotate-button`}
                                    onClick={() =>
                                      toggleEmojiPicker("body_content")
                                    }
                                    style={{ cursor: "pointer" }}
                                  >
                                    <InsertEmoticonIcon />
                                  </div>
                                </InputAdornment>
                              ),
                            }}
                          />
                        )}
                        rules={{ required: true }}
                        name="body_content"
                        control={control}
                      />
                      <div
                        style={{
                          fontSize: "14px",
                          color: "gray",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-end",
                          flexDirection: "column",
                        }}
                      >
                        {watchAllFields.body_content
                          ? `${watchAllFields.body_content.length}/1024`
                          : "0/1024"}
                      </div>
                    </div>
                    {showBdyContentMenu && watchAllFields.body_content ? (
                      <div className="suggetionsCtr">
                        <MenuList>
                          {template_tags?.length > 0 ? (
                            template_tags.map((tag, index) => (
                              <MenuItem
                                key={index}
                                onClick={() =>
                                  handleSlecetSuggetion("body_content", tag)
                                }
                              >
                                {tag}
                              </MenuItem>
                            ))
                          ) : (
                            <p style={{ textAlign: "center" }}>Loadding...</p>
                          )}
                        </MenuList>
                      </div>
                    ) : (
                      ""
                    )}
                    {fieldFocus.body_content && (
                      <div style={instructionCss}>
                        <p style={{ marginBottom: "5px" }}>
                          Enter the text for your message.
                        </p>
                        <p style={{ marginBottom: "5px" }}>
                          To add variables to your text message ,use
                          placeholders like
                          &#123;&#123;1&#125;&#125;,&#123;&#123;2&#125;&#125;etc.
                        </p>
                        <p>
                          <strong> Formatting Instructions:</strong>
                        </p>
                        <ul>
                          <li>
                            <strong>Italicize text:</strong> _Italic text_{" "}
                          </li>
                          <li>
                            <strong>Bold text:</strong> *Bold text*
                          </li>
                          <li>
                            <strong>Monospace text / code:</strong> ```
                            Monospace text / code```
                          </li>
                          <li>
                            <strong>Strikethrough text:</strong> `~Strikethrough
                            text~`
                          </li>
                        </ul>
                      </div>
                    )}
                  </div>
                  {/*  Body Example */}
                  <div>
                    <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                      Body Example
                    </InputLabel>
                    <Controller
                      render={({ field }) => (
                        <TextField
                          onKeyUp={handlePreview}
                          {...field}
                          onFocus={() => handleFocus("body_example")}
                          onBlur={() => {
                            // handlePreview();
                            handleBlur("body_example");
                          }}
                          size="small"
                          fullWidth
                          multiline
                          sx={{
                            maxWidth: "388.58px",
                            width: "100%",
                            marginBottom: "10px",
                          }}
                        />
                      )}
                      name="body_example"
                      control={control}
                    />

                    {fieldFocus.body_example && (
                      <div style={instructionCss}>
                        <p style={{ marginBottom: "5px" }}>
                          Add variables to Message.
                        </p>
                        <p style={{ marginBottom: "5px" }}>
                          Separate Variables with "," (comma) .
                        </p>
                      </div>
                    )}
                  </div>
                  {/*   Footer Content */}
                  {watchAllFields.template_type !== "media_card_carousel" && 
                   watchAllFields.template_type !== "product_card_carousel" && (
                  <div>
                    <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                      Footer Content
                    </InputLabel>
                    <div>
                      <Controller
                        render={({ field }) => (
                          <TextField
                            onKeyUp={handlePreview}
                            {...field}
                            onFocus={() => handleFocus("footer_content")}
                            onBlur={() => {
                              // handlePreview();
                              handleBlur("footer_content");
                            }}
                            size="small"
                            fullWidth
                            sx={{
                              maxWidth: "388.58px",
                              width: "100%",
                              marginBottom: "10px",
                            }}
                            inputProps={{ maxLength: 60 }}
                          />
                        )}
                        name="footer_content"
                        control={control}
                      />
                      <div
                        style={{
                          fontSize: "14px",
                          color: "gray",
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-end",
                          flexDirection: "column",
                        }}
                      >
                        {watchAllFields.footer_content
                          ? `${watchAllFields.footer_content.length}/60`
                          : "0/60"}
                      </div>
                    </div>
                    {fieldFocus.footer_content && (
                      <div style={instructionCss}>
                        <p style={{ marginBottom: "5px" }}>
                          Add a short line of text to the bottom of your message
                          template. If you add the marketing opt-out button, the
                          associated footer will be shown here by default.
                        </p>
                      </div>
                    )}
                  </div>
                  )}
                  {/* Category */}

                  {/* custom buttons */}
                  {watchAllFields.template_type !== "catalog" && (
                    <Controller
                      name={"isButtons"}
                      control={control}
                      render={({ field }) => (
                        <FormControlLabel
                          control={
                            <Switch
                              {...field}
                              checked={field.value}
                              color="primary"
                            />
                          }
                          label={"Add Buttons"}
                        />
                      )}
                    />
                  )}
                  {watchAllFields.isButtons &&
                    watchAllFields.template_type !== "catalog" && (
                      <div>
                        <Stack
                          flexDirection={"row"}
                          justifyContent={"space-between"}
                        >
                          <Typography variant="h7">Buttons:</Typography>
                          <IconButton
                            sx={{
                              color: "#25d366",
                            }}
                            disabled={buttons.length <= 10 ? false : true}
                            onClick={() =>
                              buttons.length <= 10 &&
                              appendButton({
                                type: "",
                              })
                            }
                          >
                            <AddCircleIcon
                              style={{ height: "20px", width: "20px" }}
                            />
                          </IconButton>
                        </Stack>
                        <p
                          style={{
                            backgroundColor: "#efefef",
                            margin: "10px 10px 10px 10px",
                            borderRadius: "4px",
                            color: "#14181b",
                            padding: "5px",
                            fontSize: "10px",
                          }}
                        >
                          Create up to 10 buttons that let customers respond to
                          your message or take action.
                        </p>
                        <Stack gap={1}>
                          {buttons.map((btn, index) => (
                            <Card sx={{ padding: "10px" }}>
                              <Stack
                                gap={1}
                                flexDirection={"row"}
                                justifyContent={"space-between"}
                                alignItems={"center"}
                              >
                                <Stack gap={1} sx={{ width: "300px" }}>
                                  <Controller
                                    rules={{
                                      required: "Type is required",
                                    }}
                                    name={`buttons.${index}.type`}
                                    control={control}
                                    render={({
                                      field: { value, onChange },
                                      fieldState,
                                    }) => (
                                      <Autocomplete
                                        value={value || null}
                                        options={buttonTypes}
                                        getOptionLabel={(option) =>
                                          capitalize(option)
                                        }
                                        onChange={(e, data) => onChange(data)}
                                        isOptionEqualToValue={(option, value) =>
                                          option === value
                                        }
                                        renderInput={(params) => (
                                          <TextField
                                            {...params}
                                            size="small"
                                            fullWidth
                                            error={!!fieldState.error}
                                            helperText={
                                              fieldState.error
                                                ? fieldState.error.message
                                                : null
                                            }
                                            placeholder="Button Type"
                                          />
                                        )}
                                      />
                                    )}
                                  />

                                  <Controller
                                    control={control}
                                    name={
                                      watchAllFields.buttons[index]?.type ===
                                      "COPY_CODE"
                                        ? `buttons.${index}.example`
                                        : `buttons.${index}.text`
                                    }
                                    render={({ field }) => (
                                      <TextField
                                        onKeyUp={handlePreview}
                                        {...field}
                                        size="small"
                                        placeholder={
                                          watchAllFields.buttons[index]
                                            ?.type === "COPY_CODE"
                                            ? "Example"
                                            : "Text"
                                        }
                                        sx={{
                                          maxWidth: "310px",
                                          width: "100%",
                                        }}
                                        inputProps={{
                                          maxLength: 25,
                                        }}
                                      />
                                    )}
                                  />

                                  {watchAllFields.buttons[index]?.type ===
                                    "PHONE_NUMBER" && (
                                    <Controller
                                      render={({
                                        field: { onChange, value },
                                      }) => (
                                        <PhoneInput
                                          // value={phoneNo}
                                          value={value}
                                          onChange={onChange}
                                          specialLabel={""}
                                          country={"in"}
                                          inputStyle={{
                                            width: "100%",
                                            maxWidth: "310px",
                                            height: "40px",
                                            background: "#ffff",
                                            border: "solid 1px #c4c4c4",
                                            borderRadius: "4px",
                                          }}
                                          placeholder="Phone Number"
                                          inputProps={{
                                            name: "phone_number",
                                          }}
                                          buttonStyle={{
                                            border: "solid 1px #7C8686",
                                          }}
                                          dropdownClass={"countryDropDownCss"}
                                          // onBlur={handleValidation}
                                          // defaultErrorMessage={"Invalid Phone number"}
                                          isValid={(value, country) => {
                                            if (value.length > 10) {
                                              return true;
                                            } else {
                                              return false;
                                            }
                                          }}
                                          onKeyUp={handlePreview}
                                        />
                                      )}
                                      name={`buttons.${index}.phone_number`}
                                      control={control}
                                    />
                                  )}

                                  {watchAllFields.buttons[index]?.type ===
                                    "URL" && (
                                    <Controller
                                      control={control}
                                      name={`buttons.${index}.url_type`}
                                      render={({ field: { value, onChange } }) => (
                                        <Autocomplete
                                          value={value || "STATIC_URL"}
                                          options={urlButtonTypes}
                                          getOptionLabel={(option) =>
                                            option === "STATIC_URL"
                                              ? "Static URL"
                                              : "Dynamic URL"
                                          }
                                          onChange={(e, data) =>
                                            onChange(data || "STATIC_URL")
                                          }
                                          isOptionEqualToValue={(option, val) =>
                                            option === val
                                          }
                                          disableClearable
                                          renderInput={(params) => (
                                            <TextField
                                              {...params}
                                              size="small"
                                              fullWidth
                                              sx={{
                                                maxWidth: "310px",
                                                width: "100%",
                                                marginBottom: "10px",
                                              }}
                                            />
                                          )}
                                        />
                                      )}
                                    />
                                  )}
                                  {watchAllFields.buttons[index]?.type ===
                                    "URL" &&
                                    watchAllFields.buttons[index]?.url_type !==
                                      "DYNAMIC_URL" && (
                                    <Controller
                                      control={control}
                                      name={`buttons.${index}.url`}
                                      render={({ field }) => (
                                        <TextField
                                          onKeyUp={handlePreview}
                                          {...field}
                                          size="small"
                                          placeholder="URL"
                                          sx={{
                                            maxWidth: "310px",
                                            width: "100%",
                                            marginBottom: "10px",
                                          }}
                                          inputProps={{
                                            maxLength: 255,
                                          }}
                                        />
                                      )}
                                    />
                                  )}
                                  {watchAllFields.buttons[index]?.type ===
                                    "URL" &&
                                    watchAllFields.buttons[index]?.url_type ===
                                      "DYNAMIC_URL" && (
                                    <Controller
                                      control={control}
                                      name={`buttons.${index}.dynamic_url_placeholder`}
                                      render={({ field }) => (
                                        <TextField
                                          onKeyUp={handlePreview}
                                          {...field}
                                          size="small"
                                          placeholder="e.g., {{1}} or {{product_url}}"
                                          sx={{
                                            maxWidth: "310px",
                                            width: "100%",
                                            marginBottom: "10px",
                                          }}
                                          inputProps={{
                                            maxLength: 255,
                                          }}
                                        />
                                      )}
                                    />
                                  )}
                                </Stack>

                                <IconButton
                                  sx={{
                                    color: "#df1d5a",
                                  }}
                                  disabled={buttons.length <= 1}
                                  onClick={() =>
                                    buttons.length != 1 && removeButton(index)
                                  }
                                >
                                  <RemoveCircleIcon
                                    style={{ height: "20px", width: "20px" }}
                                  />
                                </IconButton>
                              </Stack>
                            </Card>
                          ))}
                        </Stack>
                        {/* Gopi */}
                      </div>
                    )}
                  {/* catalog buttons */}
                  {watchAllFields.template_type === "catalog" && (
                    <>
                      <div>
                        <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                          Button type
                        </InputLabel>
                        <Controller
                          control={control}
                          name={`buttons.0.type`}
                          render={({ field }) => (
                            <TextField
                              // onKeyUp={handlePreview}
                              {...field}
                              size="small"
                              fullWidth
                              defaultValue="Catalog"
                              placeholder="Button Type"
                              inputProps={{
                                maxLength: 25,
                              }}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          )}
                        />
                      </div>
                      <div>
                        <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                          Button text
                        </InputLabel>
                        <Controller
                          control={control}
                          name={`buttons.0.text`}
                          render={({ field }) => (
                            <TextField
                              // onKeyUp={handlePreview}
                              {...field}
                              size="small"
                              fullWidth
                              defaultValue="View Catalog"
                              placeholder="Button Text"
                              inputProps={{
                                maxLength: 25,
                              }}
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          )}
                        />
                      </div>
                    </>
                  )}
                  {["product_card_carousel", "multi_product_message"].includes(watchAllFields.template_type) && (
                    <>
                      <InputLabel sx={{ color: "#303535", margin: "5px 0" }}>
                        Select catalog *
                      </InputLabel>
                      <Controller
                        name="catalog_obj"
                        control={control}
                        rules={{ required: "Catalog is required" }}
                        render={({ field: { value, onChange } }) => (
                          <Autocomplete
                            value={value || null}
                            options={catalogs}
                            getOptionLabel={(opt) => opt?.name || ""}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={(e, data) => {
                              onChange(data);
                              handleCatalogChange(data); // sets commerce_catalog_id + loads products
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                onKeyUp={handlePreview}
                                size="small"
                                placeholder="Select catalog"
                                error={Boolean(errors?.catalog_obj)}
                                helperText={errors?.catalog_obj?.message}
                              />
                            )}
                          />
                        )}
                      />
                    </>
                  )}

                  {watchAllFields.template_type === "media_card_carousel" && (
                    <CarouselBuilder
                      templateType="media_card_carousel"
                      value={watchAllFields.cards || []}
                      onChange={(val) => setValue("cards", val)}
                      handlePreview={handlePreview}
                      appToken={appToken}
                    />
                  )}

                  {watchAllFields.template_type === "product_card_carousel" && (
                    <CarouselBuilder
                      templateType="product_card_carousel"
                      value={watchAllFields.cards || []}
                      onChange={(val) => setValue("cards", val)}
                      handlePreview={handlePreview}
                      products={products}
                      appToken={appToken}
                    />
                  )}

                  {watchAllFields.template_type === "multi_product_message" && (
                    <ProductSectionsBuilder
                      value={watchAllFields.product_sections || []}
                      onChange={(val) => setValue("product_sections", val)}
                      handlePreview={handlePreview}
                      products={products}
                      appToken={appToken}
                    />
                  )}

                  {/* submit Buttons */}
                  <div style={{ display: "flex" }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={BtnCSS}
                      onClick={handleSubmit(() => onSubmit("send_to_draft"))}
                      name="send_to_draft"
                    >
                      Save
                    </Button>
                    {editData && (
                      <Button
                        variant="contained"
                        fullWidth
                        sx={BtnCSS}
                        onClick={handleSubmit(() => onSubmit("send_to_review"))}
                        name="send_to_review"
                      >
                        Send to Review
                      </Button>
                    )}
                  </div>
                </form>
              </FormProvider>
            </div>

            {/* preview */}

            <div
              style={{
                backgroundColor: "#f5f5f5",
                maxWidth: "400px",
                minWidth: "300px",
                width: "100%",
                minHeight: "200px",
                margin: "0 auto 0 auto",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "10px",
                flexDirection: "column",
                padding: "10px",
              }}
            >
              {showEmojiPicker && (
                <div
                  className="emojiPicker"
                  onKeyDown={(event) => {
                    if (event.key === "Escape") {
                      event.stopPropagation();
                      setShowEmojiPicker(false);
                    }
                  }}
                >
                  <EmojiPicker onEmojiClick={handleEmojiSelect} />
                </div>
              )}
              {previewLoading ? (
                <p>Loading...</p>
              ) : preview ? (
                <>
                  <div className="preview">
                    <div className="previewMCtr">
                      {selectedMedia === "image" && media ? (
                        <>
                          <Avatar
                            src={media}
                            alt="Image Preview"
                            style={{ marginTop: "10px" }}
                            name="header"
                          />
                          {preview?.body && (
                            <p style={{ whiteSpace: "pre-wrap" }}>
                              {parseFormattedText(preview?.body)}
                            </p>
                          )}

                          <p>{preview?.footer}</p>
                          {cardInsideButtons(preview.buttons)}
                        </>
                      ) : selectedMedia === "document" && media ? (
                        <>
                          <a
                            style={{
                              display: "flex",
                              alignItems: "center",
                              marginTop: "5px",
                              paddingTop: "5px",
                              borderTop: "1px solid #f2f2f2",
                              wordBreak: "break-all",
                              overflowWrap: "break-word",
                            }}
                            href={media}
                            target="_blank"
                            name="header"
                          >
                            <PictureAsPdfIcon />
                            {mediaName}
                          </a>
                          <p>{parseFormattedText(preview?.body)}</p>
                          <p>{preview.footer}</p>
                          {cardInsideButtons(preview.buttons)}
                        </>
                      ) : (
                        <>
                          {preview.header && preview.header.includes("http") ? (
                            <Avatar
                              src={preview.header}
                              alt="Image Preview"
                              style={{ marginTop: "10px" }}
                              name="header"
                            />
                          ) : (
                            <p>{preview.header}</p>
                          )}
                          <p>{parseFormattedText(preview?.body)}</p>

                          <p>{preview.footer}</p>
                          {cardInsideButtons(preview.buttons)}
                          {watchAllFields.template_type === "media_card_carousel" && Array.isArray(preview.cards) && watchAllFields?.cards && (
                            <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, py: 1 }}>
                              {buildCardPreview(preview.cards).map((c, i) => (
                                <Card key={i} sx={{ minWidth: 200, borderRadius: 2, boxShadow: 1 }}>
                                  {c._preview_src && (
                                    <CardMedia component="img" image={c._preview_src} sx={{ height: 140, objectFit: "cover", borderRadius: "8px 8px 0 0" }} />
                                  )}
                                  <CardContent sx={{ pt: 1 }}>
                                    <Typography variant="subtitle2" fontWeight="bold">{c.title}</Typography>
                                    {c.description && (
                                      <Typography variant="body2" color="text.secondary">{c.description}</Typography>
                                    )}
                                    <Stack direction="row" gap={1} sx={{ mt: 1 }}>
                                      {(c.buttons || []).map((btn, bi) => (
                                        <Button key={bi} variant="outlined" size="small" fullWidth sx={{ mt: 1 }}>
                                          {btn.text}
                                        </Button>
                                      ))}
                                    </Stack>
                                  </CardContent>
                                </Card>
                              ))}
                            </Box>
                          )}

                          {/* Product card carousel */}
                          {watchAllFields.template_type === "product_card_carousel" && Array.isArray(preview.cards) && (
                            <Box sx={{ display: 'flex', overflowX: 'auto', gap: 1, py: 1 }}>
                              {buildCardPreview(preview.cards).map((c, i) => (
                                <Card key={i} sx={{ minWidth: 220, borderRadius: 2, boxShadow: 1 }}>
                                  {c._preview_src && (
                                    <CardMedia component="img" image={c._preview_src} sx={{ height: 140, objectFit: 'cover' }} />
                                  )}
                                  <CardContent sx={{ pt: 1 }}>
                                    <Typography variant="subtitle2">{c.title || c.product_id}</Typography>
                                    {c.description && (
                                      <Typography variant="body1" color="text.secondary" gutterBottom>{c.price}</Typography>
                                    )}
                                    <Button variant="outlined" fullWidth color="primary" sx={{ textTransform: 'none', mt:1, color: "#19d257ff", borderColor : "#19d257ff" }}>
                                      View
                                    </Button>
                                  </CardContent>
                                </Card>
                              ))}
                            </Box>
                          )}

                          {/* Multi product message sections */}
                          {watchAllFields.template_type === "multi_product_message" && Array.isArray(preview.product_sections) && (
                            <Box
                              sx={{
                                display: "flex",
                                flexDirection: "column",
                                gap: 2,
                                py: 2,
                              }}
                            >
                              {preview.product_sections.map((section, i) => (
                                <Card key={i} sx={{ p: 2, borderRadius: 2, boxShadow: 1 }}>
                                  {/* ✅ Section title */}
                                  <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                    {section.title}
                                  </Typography>

                                  {/* ✅ Product list with image */}
                                  <Stack direction="column" gap={1}>
                                    {(section.products || []).map((product, pi) => (
                                      <Box
                                        key={pi}
                                        sx={{
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "space-between",
                                          borderBottom: "1px solid #eee",
                                          pb: 1,
                                        }}
                                      >
                                        {/* Product image */}
                                        {product.image_url && (
                                          <Avatar
                                            src={product.image_url}
                                            alt={product.title}
                                            sx={{ width: 48, height: 48, mr: 2 }}
                                          />
                                        )}

                                        {/* Product name + price */}
                                        <Box
                                          sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            flexGrow: 1,
                                          }}
                                        >
                                          <Typography variant="body1">{product.title}</Typography>
                                          <Typography variant="body1">{product.price}</Typography>
                                        </Box>
                                      </Box>
                                    ))}
                                  </Stack>
                                </Card>
                              ))}
                            </Box>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  {cardOutSideButtons(preview.buttons)}
                </>
              ) : (
                <>
                  <p>&nbsp;</p>
                </>
              )}
            </div>
          </Stack>
        </DialogContent>
      </Dialog>
      {ApiLoading && (
        <div className="overlay">
          <Spinner_2 style={{ width: "80px" }} />
        </div>
      )}
    </div>
  );
};
